// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    API_URL: 'https://api-urgex.webilio.dev/api/',
    STORAGE_IMAGE: 'https://api-urgex.webilio.dev/storage/',
    TINYMCE_KEY: 'vh5d1r3zbsnjrmbeir7tlx9zd0vrz1ieay6orgfxt6fktg5n'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
